import { Routes, Route, Navigate } from 'react-router-dom';
import { DashGrowthLoop } from '../pages/DashGrowthLoop';
import { DashTools } from '../pages/DashTools';
import { DashLibrary } from '../pages/DashLibrary';
import VideoLibrary from '../pages/VideoLibrary';
import VideoPlayer from '../pages/VideoPlayer';
import VideoFavorites from '../pages/VideoFavorites';
import VideoHistory from '../pages/VideoHistory';
import AdminVideos from '../pages/AdminVideos';
import AdminVideoForm from '../pages/AdminVideoForm';

export default function DashboardRoutes() {
  return (
    <Routes>
      <Route path="growth" element={<DashGrowthLoop />} />
      <Route path="library" element={<DashLibrary />} />
      <Route path="tools" element={<DashTools />} />
      <Route path="videos" element={<VideoLibrary />} />
      <Route path="videos/watch" element={<VideoPlayer />} />
      <Route path="videos/favorites" element={<VideoFavorites />} />
      <Route path="videos/history" element={<VideoHistory />} />
      <Route path="videos/:id" element={<VideoPlayer />} />
      <Route path="admin/videos" element={<AdminVideos />} />
      <Route path="admin/videos/new" element={<AdminVideoForm />} />
      <Route path="admin/videos/edit/:id" element={<AdminVideoForm />} />
      <Route path="" element={<Navigate to="growth" replace />} />
    </Routes>
  );
} 